import React from 'react';

import { useIntl } from 'react-intl';

import QRCode from 'components/qrcode';
import { ILoyaltyCard } from 'generated/rbi-graphql';
import { generateCardIdLabel } from 'pages/account/tims-rewards/details';

import { LoadingIndicator } from '../../loading-indicator';
import { ContentBlock, HeaderContainer, Heading, SubHeading } from '../../styled';

import { BARCODE_OPTIONS } from './constants';
import { CardNumber, QRCodeContainer, QRCodeWrapper } from './styled';

interface IScanQRContentProps {
  loading: boolean;
  loadingTier: boolean;
  activeCard: ILoyaltyCard | null;
}

export const ScanQRContent = ({ loading, loadingTier, activeCard }: IScanQRContentProps) => {
  const { formatMessage } = useIntl();
  return (
    <ContentBlock>
      {loading || loadingTier ? (
        <LoadingIndicator />
      ) : (
        <>
          <HeaderContainer>
            <Heading>{formatMessage({ id: 'scanForTimsRewards' })}</Heading>
            <SubHeading>{formatMessage({ id: 'putThisCodeUnderTheScanner' })}</SubHeading>
          </HeaderContainer>
          <QRCodeWrapper>
            <QRCodeContainer>
              <QRCode
                barcode={activeCard ? `${activeCard.barcode}|SR` : ''}
                options={BARCODE_OPTIONS}
              />
            </QRCodeContainer>
          </QRCodeWrapper>
          <SubHeading>{formatMessage({ id: 'yourTimsRewardsNumber' })}</SubHeading>
        </>
      )}
      {activeCard && <CardNumber>{generateCardIdLabel(activeCard.cardId)}</CardNumber>}
    </ContentBlock>
  );
};

export default ScanQRContent;
